import { render, staticRenderFns } from "./symptomCategoryListing.vue?vue&type=template&id=5a23ffea&scoped=true"
import script from "./symptomCategoryListing.vue?vue&type=script&lang=js"
export * from "./symptomCategoryListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a23ffea",
  null
  
)

export default component.exports